import React from 'react';
import { Box, Typography } from '@mui/material';
import Card from 'dashboard/components/card/Card.js';
import InputField from 'dashboard/components/fields/InputField';

export default function Socials(props) {
  return (
    <Card sx={{ mb: '20px' }} {...props}>
      <Box mb='30px' ml='10px'>
        <Typography variant='h6' fontWeight='bold'>Social Profiles</Typography>
        <Typography variant='body2' color='text.secondary'>
          Here you can set user social profiles
        </Typography>
      </Box>
      <InputField mb='25px' id='twitter_username' label='Twitter Username' placeholder='Twitter Username' />
      <InputField mb='25px' id='facebook_username' label='Facebook Username' placeholder='Facebook Username' />
      <InputField mb='25px' id='github_username' label='Github Username' placeholder='Github Username' />
      <InputField mb='25px' id='dribbble_username' label='Dribbble Username' placeholder='Dribbble Username' />
    </Card>
  );
}
